import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "../../util/axiosConfig";
import {CATEGORY_LIST} from "../../global/globalProps";
import TiptapEditor from "../../component/TiptapEditor";
import "../../assets/css/container/board/UpdatePost.css";

type Attachment = {id: number; originalName: string; sizeBytes: number};

function UpdatePost() {
    const {postId} = useParams<{postId: string}>();
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [category, setCategory] = useState("");
    const [content, setContent] = useState("");
    const [attachments, setAttachments] = useState<Attachment[]>([]);
    const [removedIds, setRemovedIds] = useState<number[]>([]);
    const [files, setFiles] = useState<File[]>([]);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!postId) return;
        axios.get(`/api/board/${postId}`).then(res => {
            setTitle(res.data.title);
            setCategory(res.data.category);
            setContent(res.data.content || "");
        }).catch(error => console.error("게시글 조회 실패:", error));
        axios.get<Attachment[]>(`/api/board/${postId}/attachments`)
            .then(res => setAttachments(res.data))
            .catch(error => console.error("첨부파일 조회 실패:", error));
    }, [postId]);

    const addAttachment = (file: File) => {
        if (attachments.length - removedIds.length + files.length >= 5 || file.size > 10 * 1024 * 1024) {
            alert("첨부파일은 총 5개, 각 10MB까지 추가할 수 있습니다.");
            return;
        }
        setFiles(previous => [...previous, file]);
    };

    const handleUpdate = async () => {
        if (!postId || saving) return;
        if (!title.trim() || !category || !content.trim()) {
            alert("제목, 카테고리, 내용을 모두 입력해 주세요.");
            return;
        }
        setSaving(true);
        try {
            const form = new FormData();
            form.append("title", title);
            form.append("category", category);
            form.append("content", content);
            removedIds.forEach(id => form.append("removedIds", String(id)));
            files.forEach(file => form.append("files", file));
            await axios.post(`/api/board/update-with-attachments/${postId}`, form);
            alert("게시글을 수정했습니다.");
            navigate(`/viewPost/${postId}`);
        } catch (error) {
            console.error("게시글 수정 실패:", error);
            alert("수정 중 오류가 발생했습니다.");
        } finally {
            setSaving(false);
        }
    };

    return <div className="UpdatePost">
        <textarea className="SetTitle" placeholder="제목을 입력해 주세요" value={title} onChange={e => setTitle(e.target.value)} />
        <select className="SetCategory" value={category} onChange={e => setCategory(e.target.value)}>
            <option value="">-- 카테고리를 선택하세요 --</option>
            {CATEGORY_LIST.map(name => <option key={name} value={name}>{name}</option>)}
        </select>
        <TiptapEditor content={content} onChange={setContent} onAttachmentSelected={addAttachment} />
        {(attachments.length > 0 || files.length > 0) && <div className="PostAttachmentsEditor">
            <h3>첨부파일</h3>
            <ul>{attachments.filter(file => !removedIds.includes(file.id)).map(file => <li key={file.id}>
                {file.originalName} <button type="button" onClick={() => setRemovedIds(previous => [...previous, file.id])}>삭제</button>
            </li>)}</ul>
            <ul>{files.map((file, index) => <li key={index}>{file.name} <button type="button" onClick={() => setFiles(files.filter((_, i) => i !== index))}>제거</button></li>)}</ul>
        </div>}
        <button className="UpdateBtn" onClick={handleUpdate} disabled={saving}>{saving ? "저장 중..." : "수정하기"}</button>
    </div>;
}

export default UpdatePost;
